import { Component } from '@angular/core';

@Component({
    selector: 'mianView',
    templateUrl: 'main-view.template.html'
})
export class mainViewComponent { }


// WEBPACK FOOTER //
// ./src/app/views/main-view/main-view.component.ts